"use client";

import React from "react";
import { MapPin, Phone, Mail, User } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const offices = [{
  id: "hq",
  region: "Global Headquarters",
  country: "World City",
  director: "Jane Doe",
  address: "456 Global Avenue, City Center, World City",
  phone: "+1 234 567 8901",
  email: "contact@aoto.com",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/flag_global_hq.png",
  fallback: "HQ"
}, {
  id: "apac",
  region: "Asia Pacific",
  country: "Singapore",
  director: "Michael Zhang",
  address: "128 Marina Way, Financial District, Singapore",
  phone: "+65 6789 0123",
  email: "apac@aoto.com",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/flag_singapore_apac.png",
  fallback: "SG"
}, {
  id: "mea",
  region: "Middle East & Africa",
  country: "UAE",
  director: "Sarah Al-Fayed",
  address: "Boulevard Plaza, Downtown Dubai, UAE",
  phone: "+971 4 123 4567",
  email: "mea@aoto.com",
  flagImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/flag_uae_mea.png",
  fallback: "AE"
}];
export default function RegionalPresence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="regional-presence" className="bg-background py-24 sm:py-32" ref={ref}>
      
    </section>;
}